import React, { useState, useEffect, useContext, useRef } from 'react';
import { useDrag } from 'react-dnd';
import { PlanoContext } from './PlanoContext';
import Swal from 'sweetalert2';
import DimensionChangeModal from './DimensionChangeModal';
import { Button } from '@material-ui/core';

function ProductCard({ prod, url, TCN, i, setProds, newProds, newURL }) {
  const [didDrop, setDidDrop] = useState(false);
  const [show, setShow] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const imageRef = useRef(null);
  const { prods, error, setError } = useContext(PlanoContext);

  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: 'product',
      item: { prod: prod },
      end: (item, monitor) => {
        if (!monitor.didDrop()) {
          setDidDrop(true);
        } else {
          setDidDrop(false);
        }
      },
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    }),
    [prod]
  );

  useEffect(() => {
    if (error != '' && didDrop) {
      Swal.fire(`Can't place the product here`, error, 'error');
      setError('');
      setDidDrop(false);
    }
  }, [didDrop]);

  const finalWidth = () => {
    if (newURL === 'ZTplano') {
      return prod.dimension.length / 3;
    } else {
      return prod.dimension.length;
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Delay image loading by 2 seconds
            const timer = setTimeout(() => {
              setIsImageLoaded(true);
              observer.unobserve(entry.target);
            }, 2000);

            return () => clearTimeout(timer);
          }
        });
      },
      {
        root: null, // viewport
        rootMargin: '0px',
        threshold: 0.1, // trigger when 10% of the image is visible
      }
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => {
      if (imageRef.current) {
        observer.unobserve(imageRef.current);
      }
    };
  }, []);

  const renderImage = (imageUrl) => {
    return (
      <img
        ref={(el) => {
          drag(el);
          imageRef.current = el;
        }}
        loading="lazy"
        style={{
          border: isDragging ? '5px solid pink' : '0px',
          maxWidth: '100%',
          maxHeight: '100%',
          opacity: isImageLoaded ? 1 : 0.5,
          filter: isImageLoaded ? 'none' : 'blur(5px)',
          transition: 'opacity 0.5s, filter 0.5s',
        }}
        src={isImageLoaded ? imageUrl : ''}
        alt={prod.name || 'Product'}
      />
    );
  };

  if (prod.empty) {
    return (
      <div className="card flex-row prodCard-plano" style={{ marginTop: '0px', borderRadius: '0' }}>
        <div className="d-flex align-items-center justify-content-center" style={{ width: '100%' }}>
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ width: '150px', height: '120px', display: 'block' }}
          >
            {renderImage(prod.productPictures[0])}
          </div>
          <div
            className="card-body d-flex"
            style={{ padding: '10px 1px 10px 1px', display: 'flex', flexDirection: 'column' }}
          >
            <h6 className="card-title" style={{ marginBottom: '5px' }}>
              Empty Slot
            </h6>
            <p className="card-text" style={{ marginBottom: '5px' }}>
              Width: {prod.dimension.length} cm
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card flex-row prodCard-plano" style={{ marginTop: '0px', borderRadius: '0' }}>
      <div className="d-flex align-items-center justify-content-center" style={{ width: '100%' }}>
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ width: '150px', height: '120px', display: 'block' }}
        >
          {renderImage(url)}
        </div>
        <div
          className="card-body d-flex"
          style={{ padding: '10px 1px 10px 1px', display: 'flex', flexDirection: 'column' }}
        >
          <h6 className="card-title" style={{ marginBottom: '5px' }}>
            {prod.name}
          </h6>
          <p className="card-text" style={{ marginBottom: '5px' }}>
            ${prod.price}
          </p>
          {!TCN ? (
            <div>
              <p className="card-text" style={{ marginBottom: '5px' }}>
                Lanes required: {prod.dimension.lane} lanes
              </p>
              <p className="card-text" style={{ marginBottom: '5px' }}>
                Depth required: {prod.dimension.step} steps
              </p>
              <p className="card-text" style={{ marginBottom: '5px' }}>
                Vertical slot required: {prod.dimension.height} slots
              </p>

              {/* <div style={{ width: '65%', margin: 'auto' }} className="card-text">
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setShow(true);
                  }}
                >
                  Edit Dimensions
                </Button>
              </div> */}
            </div>
          ) : (
            <div>
              <p className="card-text" style={{ marginBottom: '5px' }}>
                Width: {finalWidth()} cm
              </p>
              <p className="card-text" style={{ marginBottom: '5px' }}>
                Depth: {prod.dimension.width} cm
              </p>
              <p className="card-text" style={{ marginBottom: '5px' }}>
                Vertical slot required: {prod.dimension.height}
              </p>
            </div>
          )}
        </div>
      </div>
      <DimensionChangeModal
        newProds={newProds}
        setProds={setProds}
        prod={prod}
        show={show}
        onHide={() => setShow(false)}
        prods={prods}
        i={i}
      />
    </div>
  );
}

export default ProductCard;
